import { render, staticRenderFns } from "./quick-detail.vue?vue&type=template&id=87257da4&scoped=true"
import script from "./quick-detail.vue?vue&type=script&lang=ts"
export * from "./quick-detail.vue?vue&type=script&lang=ts"
import style0 from "./quick-detail.vue?vue&type=style&index=0&id=87257da4&prod&lang=scss"
import style1 from "./quick-detail.vue?vue&type=style&index=1&id=87257da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87257da4",
  null
  
)

export default component.exports